<div class="m-form__group">
    <form #f="ngForm" [attr.data-test-id]="testId + '.form'">
        <h2 class="section-title" [attr.data-test-id]="testId + '.title'">Identity Information</h2>
        <div class="row">
            <div [class]="cssWidthClass">
                <mat-form-field class="mat-form-field-fluid">
                    <mat-label [attr.data-test-id]="testId + '.id-type-label'">Identification Document</mat-label>
                    <mat-select [(ngModel)]="applicant.idType" name="identityType"
                                #idtType="ngModel" required
                                [attr.data-test-id]="testId + '.id-type-select'">
                        <mat-option *ngFor="let type of identityTypeList" [value]="type.value"
                                    id="{{type.name}}"
                                    [attr.data-test-id]="testId + '.id-type-option.' + type.value?.toLowerCase()">{{type.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="idtType.hasError('required')" [attr.data-test-id]="testId + '.id-type.required-error'">
                        Please Select an identity type.
                    </mat-error>
                </mat-form-field>
            </div>

            <div [class]="cssWidthClass" *ngIf="applicant.idType === 'Passport'">
                <mat-form-field class="mat-form-field-fluid">
                    <mat-label [attr.data-test-id]="testId + '.passport-country-label'">Issue Country</mat-label>
                    <mat-select [(ngModel)]="applicant.idIssuer" name="identityIssuedBy"
                                #dLs="ngModel" required
                                [attr.data-test-id]="testId + '.passport-country-select'">
                        <mat-option *ngFor="let country of countryList" [value]="country.alpha3"
                                    id="{{country.alpha3}}"
                                    [attr.data-test-id]="testId + '.passport-country-option.' + country.alpha3.toLowerCase()">{{country.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="dLs.hasError('required')" [attr.data-test-id]="testId + '.passport-country.required-error'">
                        Please enter the issuing authority.
                    </mat-error>
                </mat-form-field>
            </div>

            <div [class]="cssWidthClass" *ngIf="applicant.idType === 'stateID'">
                <mat-form-field class="mat-form-field-fluid">
                    <mat-label [attr.data-test-id]="testId + '.state-id-issuer-label'">State of issuer</mat-label>
                    <mat-select [(ngModel)]="applicant.idIssuer" name="identityIssuedBy"
                                #dLs="ngModel" required
                                [attr.data-test-id]="testId + '.state-id-issuer-select'">
                        <mat-option *ngFor="let state of drivingLicenceStateList" [value]="state.code"
                                    id="{{state.name}}"
                                    [attr.data-test-id]="testId + '.state-id-issuer-option.' + state.code?.toLowerCase()">{{state.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="dLs.hasError('required')" [attr.data-test-id]="testId + '.state-id-issuer.required-error'">
                        Please enter the issuing authority.
                    </mat-error>
                </mat-form-field>
            </div>

            <div [class]="cssWidthClass" *ngIf="applicant.idType === 'militaryID'">
                <mat-form-field class="mat-form-field-fluid">
                    <mat-label [attr.data-test-id]="testId + '.military-id-issuer-label'">Identity issued By</mat-label>
                    <input matInput type="text" #idtIssueBy="ngModel"
                           name="identityIssuedBy" required
                           [(ngModel)]="applicant.idIssuer"
                           [attr.data-test-id]="testId + '.military-id-issuer-input'"/>
                    <mat-error *ngIf="idtIssueBy.hasError('required')" [attr.data-test-id]="testId + '.military-id-issuer.required-error'">
                        Please enter the issuing authority.
                    </mat-error>
                </mat-form-field>
            </div>

            <ng-container *ngIf="applicant.idType === 'drivingLicence'">
                <div [class]="cssWidthClass">
                    <mat-form-field class="mat-form-field-fluid">
                        <mat-label [attr.data-test-id]="testId + '.dl-state-label'">Driver's License State</mat-label>
                        <mat-select [(ngModel)]="applicant.idIssuer" name="drivingLicenseState"
                                    #dLs="ngModel" (selectionChange)="validateDriversLicense(dL, applicant.idIssuer)" required
                                    [attr.data-test-id]="testId + '.dl-state-select'">
                            <mat-option *ngFor="let state of drivingLicenceStateList" [value]="state.code"
                                        id="{{state.name}}"
                                        [attr.data-test-id]="testId + '.dl-state-option.' + state.code?.toLowerCase()">{{state.name}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="dLs.hasError('required')" [attr.data-test-id]="testId + '.dl-state.required-error'">
                            Please select the issuing state.
                        </mat-error>
                    </mat-form-field>
                </div>

                <div [class]="cssWidthClass">
                    <mat-form-field class="mat-form-field-fluid">
                        <mat-label [attr.data-test-id]="testId + '.dl-number-label'">Driver License</mat-label>
                        <input matInput type="text" #dL="ngModel" (blur)="validateDriversLicense(dL, applicant.idIssuer)"
                               name="driverLicense" required
                               [(ngModel)]="applicant.idNumber"
                               [attr.data-test-id]="testId + '.dl-number-input'"/>
                               <mat-error *ngIf="dL.hasError('required')" [attr.data-test-id]="testId + '.dl-number.required-error'">
                                Please enter your driver's license number.
                            </mat-error>
                            <mat-error *ngIf="dL.hasError('driverLicense')" [attr.data-test-id]="testId + '.dl-number.invalid-error'">
                                Please enter a valid driver's license number.
                            </mat-error>
                            <mat-hint [attr.data-test-id]="testId + '.dl-number-hint'">Do not include '-', space or other special characters</mat-hint>
                    </mat-form-field>
                </div>
            </ng-container>

            <div [class]="cssWidthClass" *ngIf="applicant.idType !== 'drivingLicence'">
                <mat-form-field class="mat-form-field-fluid">
                    <mat-label [attr.data-test-id]="testId + '.id-number-label'">Identification Number</mat-label>
                    <input matInput type="text" #idtNumber="ngModel" maxLength="25"
                           name="identityNumber" required alphabetOnly [allowNumbers]="true"
                           [(ngModel)]="applicant.idNumber"
                           [attr.data-test-id]="testId + '.id-number-input'"/>
                    <mat-error *ngIf="idtNumber.hasError('required')" [attr.data-test-id]="testId + '.id-number.required-error'">
                        Please enter the identification number.
                    </mat-error>
                </mat-form-field>
            </div>

            <div [class]="cssWidthClass">
                <creditsnap-date #idtIssueDate [(ngModel)]="applicant.idIssueDate" [maxDate]="todayDate" label="ID Issue Date" name="idtIssueDate"
                                 [data-test-id]="testId + '.id-issue-date'">
                </creditsnap-date>
            </div>
            <div [class]="cssWidthClass">
                <creditsnap-date #idtExpDate [(ngModel)]="applicant.idExpDate" [minDate]="tomorrowDate" [maxDate]="maxIDExpDate"
                                 [allowedString]="(sharedService.calculateAge(applicant.dob) > 65 ) ? '99/99/9999' : undefined" label="ID Expiration Date"
                                 name="idtExpDate"
                                 [data-test-id]="testId + '.id-expiration-date'">
                </creditsnap-date>
            </div>
        </div>
    </form>
</div>
